import mainTheme from './main';
import { colors } from '@material-ui/core';
const white = '#FFFFFF';
const black = '#000000';
const darkGreen = '#1D6828';
const mainGreen = '#37973E';

export default {
  ...mainTheme,
  primary: {
    contrastText: white,
    dark: darkGreen,
    main: mainGreen
  },
};